// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, ChevronRight } from 'lucide-react';

// const promos = [
//   {
//     id: 1,
//     title: 'Gratis Ongkir 2km',
//     subtitle: 'Min. belanja 25k',
//     bgColor: 'from-orange-400 to-orange-500',
//     emoji: '🚚'
//   },
//   {
//     id: 2,
//     title: 'Diskon 10%',
//     subtitle: 'Produk pilihan hari ini',
//     bgColor: 'from-teal-400 to-green-500',
//     emoji: '🎉'
//   },
//   {
//     id: 3,
//     title: 'Cashback 5%',
//     subtitle: 'Untuk pembelian pertama',
//     bgColor: 'from-blue-400 to-indigo-500',
//     emoji: '💰'
//   }
// ];

// const HeroBanner = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % promos.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % promos.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prev) => (prev - 1 + promos.length) % promos.length);
//   };

//   return (
//     <div className="relative h-48 sm:h-56 rounded-xl overflow-hidden group">
//       {/* Slides */}
//       {promos.map((promo, index) => (
//         <div
//           key={promo.id}
//           className={`absolute inset-0 transition-all duration-500 ${
//             index === currentSlide ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full'
//           }`}
//         >
//           <div className={`h-full bg-gradient-to-r ${promo.bgColor} p-8 flex items-center justify-between text-white`}>
//             <div className="flex-1">
//               <div className="text-5xl mb-3">{promo.emoji}</div>
//               <h2 className="text-3xl sm:text-4xl font-bold mb-2">{promo.title}</h2>
//               <p className="text-base sm:text-lg opacity-90">{promo.subtitle}</p>
//               <button className="mt-4 px-6 py-2 bg-white text-gray-800 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
//                 Lihat Promo
//               </button>
//             </div>
//           </div>
//         </div>
//       ))}

//       {/* Navigation Buttons */}
//       <button
//         onClick={prevSlide}
//         className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white"
//       >
//         <ChevronLeft className="w-6 h-6 text-gray-800" />
//       </button>
//       <button
//         onClick={nextSlide}
//         className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white"
//       >
//         <ChevronRight className="w-6 h-6 text-gray-800" />
//       </button>

//       {/* Indicators */}
//       <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
//         {promos.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentSlide(index)}
//             className={`w-2 h-2 rounded-full transition-all ${
//               index === currentSlide ? 'bg-white w-6' : 'bg-white/50'
//             }`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default HeroBanner;

import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import axios from 'axios';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

const HeroBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch banners from API
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${API}/banners`);
        if (response.data && response.data.length > 0) {
          setBanners(response.data);
        } else {
          // Fallback to default if no banners
          setBanners([
            {
              id: 1,
              title: 'Gratis Ongkir 2km',
              subtitle: 'Min. belanja 25k',
              gradient_from: 'orange-400',
              gradient_to: 'orange-500',
              emoji: '🚚',
              link_url: null
            }
          ]);
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
        // Use default banner on error
        setBanners([
          {
            id: 1,
            title: 'Selamat Datang',
            subtitle: 'Belanja kebutuhan harian Anda',
            gradient_from: 'teal-400',
            gradient_to: 'green-500',
            emoji: '🏪',
            link_url: null
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  useEffect(() => {
    if (banners.length === 0) return;
    
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [banners]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % banners.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const handleBannerClick = (banner) => {
    if (banner.link_url) {
      window.open(banner.link_url, '_blank');
    }
  };

  if (loading || banners.length === 0) {
    return (
      <div className="h-48 sm:h-56 rounded-xl bg-muted animate-pulse"></div>
    );
  }

  return (
    <div className="relative h-48 sm:h-56 rounded-xl overflow-hidden group">
      {/* Slides */}
      {banners.map((banner, index) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-all duration-500 ${
            index === currentSlide ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full'
          }`}
          onClick={() => handleBannerClick(banner)}
          style={{ cursor: banner.link_url ? 'pointer' : 'default' }}
        >
          {banner.image_url ? (
            // Image banner
            <div className="relative h-full w-full">
              <img 
                src={banner.image_url} 
                alt={banner.title}
                className="w-full h-full object-cover"
              />
              {/* Overlay with text */}
              <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent p-8 flex items-center">
                <div className="flex-1 text-white">
                  <div className="text-5xl mb-3">{banner.emoji}</div>
                  <h2 className="text-3xl sm:text-4xl font-bold mb-2">{banner.title}</h2>
                  {banner.subtitle && (
                    <p className="text-base sm:text-lg opacity-90">{banner.subtitle}</p>
                  )}
                  {banner.link_url && (
                    <button className="mt-4 px-6 py-2 bg-white text-gray-800 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                      Lihat Promo
                    </button>
                  )}
                </div>
              </div>
            </div>
          ) : (
            // Gradient banner (fallback)
            <div className={`h-full bg-gradient-to-r from-${banner.gradient_from} to-${banner.gradient_to} p-8 flex items-center justify-between text-white`}>
              <div className="flex-1">
                <div className="text-5xl mb-3">{banner.emoji}</div>
                <h2 className="text-3xl sm:text-4xl font-bold mb-2">{banner.title}</h2>
                {banner.subtitle && (
                  <p className="text-base sm:text-lg opacity-90">{banner.subtitle}</p>
                )}
                {banner.link_url && (
                  <button className="mt-4 px-6 py-2 bg-white text-gray-800 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                    Lihat Promo
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      ))}

      {/* Navigation Buttons */}
      {banners.length > 1 && (
        <>
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white"
          >
            <ChevronLeft className="w-6 h-6 text-gray-800" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white"
          >
            <ChevronRight className="w-6 h-6 text-gray-800" />
          </button>
        </>
      )}

      {/* Indicators */}
      {banners.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 rounded-full transition-all ${
                index === currentSlide ? 'bg-white w-6' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HeroBanner;
